import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

/* export interface TranslatedData {
  translatedText: string;
  columns: { header: string, field: string }[];
} */
@Injectable({
  providedIn: 'root'
})

export class LanguageService {
  private host = environment.apiUrlHost;

  private currentLanguageSource = new BehaviorSubject<string>(localStorage.getItem('langchanged') || 'en'); // Default to 'en'
  currentLanguage$ = this.currentLanguageSource.asObservable();
  public languages: string[] = ['en', 'fr', 'De'];
  private currentLanguageSubject = new BehaviorSubject<string>(localStorage.getItem('lang'));
  //translate key::::
  private headerDataSubject = new BehaviorSubject<string[]>([]);
  headerData$ = this.headerDataSubject.asObservable();
  private translationSubject: Subject<string> = new Subject<string>();

  constructor(public translate: TranslateService, private http: HttpClient) {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang('en'); // Set your default language
    
    // Changed logic - prioritize user-selected language
    const savedLanguage = localStorage.getItem('langchanged');
    
    if (savedLanguage && this.languages.includes(savedLanguage)) {
      // User explicitly selected a language before, use that
      this.setLanguage(savedLanguage);
    } else {
      // No saved preference, use browser language
      const browserLang = this.translate.getBrowserLang();
      if (browserLang && this.languages.includes(browserLang)) {
        this.setLanguage(browserLang);
      } else {
        // Default fallback
        this.setLanguage('en');
      }
    }
  }
  getData() {
    return this.currentLanguageSubject.asObservable();
  }
  public setLanguage(lang: string) {
    const normalized = this.normalizeLanguageCode(lang) || 'en';
    this.translate.use(normalized);
    this.currentLanguageSource.next(normalized);
    localStorage.setItem('langchanged', normalized);
    this.currentLanguageSubject.next(normalized);
  }


  // public translateKey(key: string): string {
  //   return this.translate.instant(key);
  // }
  //  // Function to translate a key and return an Observable
  //  translateKeyy(key: string): Observable<string> {
  //   // Translate the key immediately
  //   this.translationSubject.next(this.translate.instant(key));

  //   // Subscribe to language change events to update translation
  //   this.translate.onLangChange.subscribe(() => {
  //     this.translationSubject.next(this.translate.instant(key));
  //   });

  //   // Return Observable for real-time updates
  //   return this.translationSubject.asObservable();
  // }
  // changeLanguage(language: string) {
  //   localStorage.setItem('lang', language);
  //   localStorage.setItem('langchanged', language);
  //   this.currentLanguageSubject.next(language);
  // }
  changeLanguage(language: string) {
    // Use setLanguage to ensure consistency
    this.setLanguage(language);
    
    // Also set the lang property for backward compatibility
    localStorage.setItem('lang', language);
  }
  getCurrentLanguage(): string {
    const langChanged = localStorage.getItem('langchanged');
    if (langChanged?.trim()) {
      return this.normalizeLanguageCode(langChanged) || 'en';
    }
    const lang = localStorage.getItem('lang');
    if (lang?.trim()) {
      return this.normalizeLanguageCode(lang) || 'en';
    }
    return 'en';
  }

  /** Normalize CF / header language codes (e.g. FR → fr) for ML records and ngx-translate. */
  normalizeLanguageCode(lang: string | null | undefined): string {
    if (!lang?.trim()) {
      return '';
    }
    return lang.trim().split('-')[0].toLowerCase();
  }


  /*  // Function to translate a key and return an Observable
  translateKeyy(key: string): Observable<string> {
   // Translate the key immediately
   this.translationSubject.next(this.translate.instant(key));

   // Subscribe to language change events to update translation
   this.translate.onLangChange.subscribe(() => {
     this.translationSubject.next(this.translate.instant(key));
   });

   // Return Observable for real-time updates
   return this.translationSubject.asObservable();
 } */
  /* translateKeys(key: string): Observable<TranslatedData> {
    // Translate the key immediately
    const translatedText = this.translate.instant(key);
    const translatedData: TranslatedData = {
      translatedText: translatedText,
      columns: this.getTranslatedColumns() // You need to implement this function
    };
    this.translationSubject.next(translatedData);

    // Subscribe to language change events to update translation
    this.translate.onLangChange.subscribe(() => {
      const updatedTranslatedText = this.translate.instant(key);
      const updatedTranslatedData: TranslatedData = {
        translatedText: updatedTranslatedText,
        columns: this.getTranslatedColumns() // You need to implement this function
      };
      this.translationSubject.next(updatedTranslatedData);
    });

    return this.translationSubject.asObservable();}
    private getTranslatedColumns(): { header: string, field: string }[] {
      // Implement logic to get translated columns
      // For now, I'm returning an empty array
      return [];
    } */

  updateHeaderData(data: any) {
    this.headerDataSubject.next(data);
  }

  // Function to consume the retrieve language api
  public searchLanguage(query): Observable<any> {
    // query parameter
    const query1 = new HttpParams().set('languageCode', query);
    return this.http.get(`${this.host}/CF/cf_languages/`, { params: query1 })
  }

  // Function to consume the create language api
  public createLanguage(data: any): Observable<any | HttpErrorResponse> {
    return this.http.post<any>(`${this.host}/CF/cf_languages/`, data)
  }

  // Function to consume the update language api
  public updatelanguage(languageCode: any, data: any): Observable<any | HttpErrorResponse> {
    return this.http.put<any>(`${this.host}/CF/cf_languages/${languageCode}`, data);
  }


}
